import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { appf_tenant_info, poolData } from "./UserPool";
import useAuth from "./useAuth";

function CheckLogin () {
  const navigate = useNavigate();
  const { getSession, refreshToken } = useAuth();
  const { state } = useLocation();
  const localPoolData = poolData;

  useEffect(() => {
      getSession().then(() => {
        localPoolData.refreshToken = refreshToken;

        if (typeof window.checkLogin !== 'undefined') {
          try {
            setTimeout(() => {
                delete window.checkLogin;
            }, 100);

            navigate( window.checkLogin || "/dashboard", { replace: true });              
          } catch (e) { /* */ }
        } else {
          navigate(state?.path || "/dashboard", { replace: true });
        }
      }, () => {
        if (!appf_tenant_info.type == "azure") {
          navigate("/login", { state, replace: true });
        } else {
          navigate("/login", { state, replace: true });
        }
      });
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  return (<></>);
}

export default CheckLogin;
